module.exports = __webpack_public_path__ + "media/images/icon_a3_blue-3597bdf87b7e2413936179690975afc0.png";